import type { RoutingDeployOutcome } from './types';

/**
 * SASADM-0170 (saas-auth SASATH-0387 §5.1) — true when a write's routing deploy did not
 * apply. Such an outcome is shown as an error banner, never as success.
 */
export function isDeployFailure(
  o: RoutingDeployOutcome | null | undefined,
): o is RoutingDeployOutcome {
  return o?.status === 'REJECTED' || o?.status === 'FAILED';
}

/**
 * SASADM-0176 (saas-auth SASATH-0391) — the deploy applied, but some tenants / products were
 * held back on their previous routing (`heldBack`).
 */
export function isDeployPartial(
  o: RoutingDeployOutcome | null | undefined,
): o is RoutingDeployOutcome {
  return o?.status === 'PARTIAL';
}

/** SASADM-0176 — any outcome that must show a banner and never a success toast. */
export function isDeployProblem(
  o: RoutingDeployOutcome | null | undefined,
): o is RoutingDeployOutcome {
  return isDeployFailure(o) || isDeployPartial(o);
}
